<template>
  <welcome class="welcome__card-wrap" />
</template>

<script>
// @ is an alias to /src
import Welcome from '@/components/layout/Welcome.vue';
export default {
  name: 'Home',
  components: {
    Welcome,
  },
};
</script>

<style lang="scss">
.welcome__card-wrap {
  margin-top: 164px;
}
</style>
